'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deriveEventPropertySchema = exports.normalizeDefinitions = undefined;

var _schemas = require('./schemas');

var _taxonomy = require('./taxonomy');

var _schema = require('../common/schema');

var schema = _interopRequireWildcard(_schema);

var _helpers = require('../common/helpers');

var _messages = require('../common/messages');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
*  v1.5 of the bender-event-definition-loader package introduced
*  the concept of "detailed properties" vs "shorthand properties".
*
*  For backwards compatibility, this code will adapt any shorthand properties
*  supported by pre v1.5 loader versions to the detailed property format.
*  The detailed property format includes additional info such as "isOptional".
*/
var _adaptShorthandProperties = function _adaptShorthandProperties(definitions) {
  return Object.keys(definitions).reduce(function (accumulator, eventKey) {
    var definition = definitions[eventKey];
    definition.properties = (0, _helpers.mapObject)(definition.properties, function (key, value) {
      var isShorthandProperty = typeof value === 'string' || (0, _helpers.isArray)(value);
      if (isShorthandProperty) {
        return {
          type: value
        };
      }
      return value;
    });
    definition.properties = _schemas.eventPropertySchema.normalizeEach(definition.properties);
    accumulator[eventKey] = definition;
    return accumulator;
  }, {});
};

var normalizeDefinitions = exports.normalizeDefinitions = function normalizeDefinitions(definitions, caller) {
  var parsedDefinitions = _schemas.eventDefinitionSchema.normalizeEach(definitions);
  _schemas.eventDefinitionSchema.validateEach(parsedDefinitions, caller);
  return _adaptShorthandProperties(parsedDefinitions);
};

/*
*  Schemas provide free validation since
*  an object can be validated against them.
*
*  This function takes an event definition,
*  and generates a schema for it's properties.
*
*  EX:
*
*    definition = {
*      name: 'page view',
*      class: 'view',
*      properties: {
*        screen: { type: 'oneOf(["foo", "bar"])', isOptional: false },
*        subscreen: { type: 'string', isOptional: false }
*      }
*    }
*
*    schema = {
*      screen: {
*        types: ['string'],
*        oneOf: ['foo', 'bar']
*      },
*      subscreen: {
*        types: ['string']
*      }
*    }
*/
var deriveEventPropertySchema = exports.deriveEventPropertySchema = function deriveEventPropertySchema(definition) {
  var properties = definition.properties || {};
  var propertiesBlueprint = Object.keys(properties).reduce(function (accumulator, key) {
    var _properties$key = properties[key],
        type = _properties$key.type,
        isOptional = _properties$key.isOptional;


    if (_taxonomy.eventPropertyTypes.indexOf(type) !== -1) {
      accumulator[key] = {
        types: [type],
        isOptional: isOptional
      };
    } else if (type.indexOf('oneOf') !== -1) {
      var options = (0, _helpers.between)(type, '[', ']').split(',').map(function (option) {
        return (0, _helpers.trim)((0, _helpers.trim)(option, '"'), "'");
      });
      accumulator[key] = {
        oneOf: options,
        isOptional: isOptional
      };
    } else if ((0, _helpers.isArray)(type)) {
      accumulator[key] = {
        oneOf: type,
        isOptional: isOptional
      };
    }

    return accumulator;
  }, {});

  return schema.create('event property', _messages.eventError, propertiesBlueprint, false);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.74/js/dictionary/adapters.js
// module id = 394
// module chunks = 0